/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import Tickers from "./tickers";
import Testimonials from "./testimonials";
//import Buttons from "./buttons";
const { Step } = Steps;
const { Panel } = Collapse;
import { Button, Card, Collapse, Steps, Row, Col, Layout } from "antd";
import { Link } from "react-router-dom";
import IsMobileView from "../../components/utils/mobileView";
import { LandingSection } from "./landing-section";

const { Content } = Layout;
const iconset = [
  "https://i.imgur.com/U8NINyM.png",
  "https://i.imgur.com/GW91z9V.png",
  "https://i.imgur.com/WgNjC36.png",
];
const Common = ({ checklist }) => {
  const isMobileView = IsMobileView();
  return (
    <Content
      style={{
        padding: 24,
        marginTop: 0,
        width: "100%",
      }}
    >
      <Tickers checklist={checklist} />
      {/*<LandingSection
        title="Generate Revenue from your Short Films!"
        colStyle={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Row gutter={16}>
          {checklist.features &&
            checklist.features.map((item, index) => (
              <Col
                xs={{ span: 22, push: 1 }}
                lg={{ span: 8, push: 0 }}
                key={index}
                style={{ marginBottom: isMobileView ? "24px" : "0px" }}
              >
                <Card
                  className="vc-panel"
                  cover={<img alt={item.title} src={iconset[index]} />}
                  style={{
                    height: "100%",
                  }}
                >
                  <h3
                    style={{
                      color: "var(--vc-text)",
                      fontSize: "24px",
                      lineHeight: "1.2",
                      fontWeight: "bold",
                    }}
                  >
                    {item.title}
                  </h3>
                  {item.description}
                </Card>
              </Col>
            ))}
        </Row>
      </LandingSection>*/}
      <LandingSection className="steps-section" title="How it Works?">
        {checklist.steps && (
          <Content
            style={{
              padding: 24,
            }}
          >
            <Steps
              current={-1}
              direction={window.innerWidth < 530 ? "vertical" : "horizontal"}
            >
              {checklist.steps.map((item, index) => (
                <Step
                  key={index}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </Steps>
          </Content>
        )}
        <br />
        <div
          style={{
            marginBottom: 64,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Link to="/demo">
            <Button type="primary" size="large">
              Take a Tour
            </Button>
          </Link>
        </div>
      </LandingSection>
      <Testimonials testimonials={checklist.testimonials} />
      <LandingSection title="FAQs">
        {checklist.faq && (
          <Collapse defaultActiveKey={["0"]} style={{ textAlign: "left" }}>
            {checklist.faq.map((item, index) => (
              <Panel header={item.title} key={index}>
                <p>{item.description}</p>
              </Panel>
            ))}
          </Collapse>
        )}
      </LandingSection>
    </Content>
  );
};
export default Common;
